import { PageItemApi } from 'api/PageItemApi';
import { PageItemAbstractMapper } from 'mapper/PageItemAbstractMapper';
import { Question } from 'model/Question';

export abstract class QuestionAbstractMapper {
  static serialize(model: Question): PageItemApi.QuestionEntry {
    return {
      ...PageItemAbstractMapper.serialize(model),
      content: model.content,
    };
  }

  static deserializeShape(entry: PageItemApi.QuestionEntry): Question {
    return {
      ...PageItemAbstractMapper.deserializeShape(entry),
      content: entry.content,
    };
  }
}
